export default (pattern: String | string, route: any, lookup: Array<{ pattern: String | string, property: String | string }> = [{ pattern: '[id]', property: 'id' }]): String | string  => {
  let requestRoute = pattern;
  lookup.forEach((item: { pattern: String | string, property: String | string }) => {
    if ((item.property as string) in route?.params)
      requestRoute = requestRoute.replace((item.pattern as string), route?.params[(item.property as string)]);
  });
  return requestRoute;
};
